import { Store } from "pullstate";

export const AuthStore = new Store({
    accessToken: null,
    refreshToken: sessionStorage.getItem('refreshToken')
});